import styled from '@emotion/styled';

export const ColorDot = styled('span')<{ color: string }>`
  display: block;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: ${({ color }) => color};
  margin-right: 8px;
`;
